var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"trend-sticker d-flex justify-content-stretch",attrs:{"to":_vm.trend.url}},[_c('mdm-stripe',{attrs:{"text":_vm.trend.sticker_label,"color":_vm.trend.sticker_bg_color ? _vm.trend.sticker_bg_color : null}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }